import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#FFF' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M23.896875 0L17.53875 8.930625H24V0h-.103125zM0 0v24h10.445625L14.3925 11.65125h-7.455L13.3558125 0H0zm11.35875 24H24V10.029375L11.35875 24z"
          fill="#FFF"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
